import myService from '../../../../services/MyService';
import useDownload from '../../../hooks/useDownload';


/**
 * Downloads the given buyer invoices for the given order id.
 * Takes the given callbacks to optionally handle complete and error state.
 *
 * @return {(function(*, *=, *=): void)|*}
 */
function useDownloadOrderBuyerTransactionReceipts() {

    const download = useDownload();

    return (orderId, onComplete = () => {}, onError = () => {}) => {

        (async () => {

            const downloadOrderBuyerTransactionReceiptsRequest = myService.createOrderBuyerTransactionReceiptDownloadRequest(orderId);
            await download(downloadOrderBuyerTransactionReceiptsRequest, onError);

            onComplete();
        })();
    };
}


export default useDownloadOrderBuyerTransactionReceipts;
